module.exports = require("./bn");